import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

export interface MapNode {
  id: string;
  title?: string | null;
  topic: string;
  site: string;
  project_name?: string | null;
  project_id?: string | null;
  team_project_id?: string | null;
  team_project_name?: string | null;
  last_captured_at: string;
  author_name?: string;
  author_role?: string;
}

export interface MapSurfaceData {
  nodes: MapNode[];
  edges: Array<{ source: string; target: string; similarity: number }>;
}

// Team-only (D5: the individual map + its /api/surfaces/map endpoint were dropped in the overhaul).
export function useMapSurface() {
  const query = useQuery({
    queryKey: ['surfaces', 'team-map'],
    queryFn: () => apiFetch<MapSurfaceData>('/api/surfaces/team/map'),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
  return {
    ...query,
    data: query.data ?? undefined,
    empty: query.data && (query.data as any).status === 'empty' ? true : undefined,
  };
}
